import { Separator } from "@/components/ui/separator"
import { SidebarTrigger } from "@/components/ui/sidebar"
import { BillingBadge } from "@/components/ui/billing-badge"

export function DashboardHeader({title}: {title: string}) {
  return (
    <header className="sticky inset-x-0 top-0 z-50 transition-all duration-300 ease-linear flex h-(--header-height) shrink-0 items-center gap-2 border-b bg-background group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className="-ml-1" />
        <Separator
          orientation="vertical"
          className="mx-2 data-[orientation=vertical]:h-4"
        />
        <h1 className="text-base font-medium">{title}</h1>
        <div className="ml-auto flex items-center gap-2">
          <BillingBadge />
        </div>
      </div>
    </header>
  )
}
